module.exports = __webpack_public_path__ + "img/47.ffd859b1.jpg";